export default __webpack_public_path__ + "static/celaya-labelbadge-05-46c25d6ab777b3bcb4092f1a847dd77c.png";